import React from "react";
import {
  criarStatusProtocoloDs,
  inserirOuAtualizar,
} from "../../DataSources.js";
import Form, {
  SimpleItem,
  GroupItem,
  Label,
  EmptyItem,
} from "devextreme-react/form";
import Memoria from "../../Memoria";
import notify from "devextreme/ui/notify";
import { Button } from "devextreme-react";
import UserInfo from "../../UserInfo";
import apiAxios from "../../api-axios";
import showError from "../../AppServices";
import ShowError from "../../AppServices";

const _versaoCadastro = 1;
let _cadastroCorrente = undefined;
let _cancelando = false;

const template = {
  id: undefined,
  prefeituraId: UserInfo.getPrefeitura(),
  descricao: "",
  situacao: undefined,
};

export default class StatusProtocoloForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = { ...(_cadastroCorrente || template) };
    this.ok = this.ok.bind(this);
    this.cancel = this.cancel.bind(this);
    this.statusProtocoloDs = criarStatusProtocoloDs();

    this.opcoesSituacao = {
      editorType: "dxSelectBox",
      placeholder: " ",
      searchEnabled: false,
      dataSource: [
        { id: 0, descricao: "NENHUM" },
        { id: 1, descricao: "RECEBIDO" },
        { id: 2, descricao: "EM ANDAMENTO" },
        { id: 3, descricao: "AGUARDANDO SOLICITANTE" },
        { id: 4, descricao: "IMPEDIDO" },
        { id: 5, descricao: "FINALIZADO" },
      ],
      valueExpr: "id",
      displayExpr: "descricao",
    };
  }

  componentDidMount() {
    if (this.props.match.params.id !== undefined) {
      this.statusProtocoloDs
        .byKey(this.props.match.params.id)
        .then((data) => {
          if (data == undefined) {
            notify("Registro não encontrado.", "error");
            this.props.history.push("/statusprotocolo");
          }

          this.setState(data);
        })
        .catch((error) => {
          showError(error.response.data);
          notify(error, "error", 2000);
          this.props.history.goBack();
        });
    }
  }

  render() {
    return (
      <React.Fragment>
        <div className={"content-block dx-card responsive-paddings"}>
          <form>
            <Form formData={this.state} colCount={2}>
              <GroupItem caption="DADOS DO STATUS" colSpan={2} colCount={4}>
                <SimpleItem
                  colSpan={1}
                  dataField={"situacao"}
                  editorType={"dxSelectBox"}
                  editorOptions={this.opcoesSituacao}
                >
                  <Label text="Situação" />
                </SimpleItem>
                <EmptyItem></EmptyItem>
                <EmptyItem></EmptyItem>
                <EmptyItem></EmptyItem>
                <SimpleItem
                  dataField={"descricao"}
                  editorType={"dxTextArea"}
                  colSpan={4}
                  editorOptions={{ height: "100px" }}
                >
                  <Label text="Descrição" />
                </SimpleItem>
              </GroupItem>
            </Form>
            <div style={{ marginTop: "10px" }}>
              <div style={{ display: "inline-block" }}>
                <Button
                  width={120}
                  text="Salvar"
                  type="success"
                  onClick={this.ok}
                />
              </div>
              <div style={{ display: "inline-block", marginLeft: "10px" }}>
                <Button text="Cancelar" onClick={this.cancel} />
              </div>
            </div>
          </form>
        </div>
      </React.Fragment>
    );
  }

  async ok() {
    if (UserInfo.getUsuarioId() === undefined)
      notify("Usuário precisa selecionar prefeitura!", "warning");
    else {
      try {
        const entidade = this.state;

        const response = await apiAxios.post(
          `/protocolos/status_protocolos/cadastrar`,
          entidade
        );

        if (response.status === 200) {
          notify("Status de Protocolo cadastrado com sucesso!", "success");
        }
      } catch (error) {
        ShowError(error.response.data);
        notify(error, "error", 2000);
      }
      this.props.history.push(`/statusprotocolo`);
    }
  }

  cancel() {
    _cadastroCorrente = undefined;
    _cancelando = true;
    notify("Operação cancelada", "warning");
    Memoria.removerEdicao(this.props.location);
    this.props.history.goBack();
  }
}
